import { Header } from "@/components/sven/Header";
import { Footer } from "@/components/sven/Footer";
import { PageHero, BookCta } from "@/components/sven/PageHero";
import { Reveal } from "@/components/sven/Reveal";

/*
 * ABOUT PAGE — PLACEHOLDER COPY throughout, client to replace with the
 * brand's real history, founder story and team details.
 */
const VALUES = [
  { num: "01", title: "One Pattern, One Man", text: "Every garment begins with a pattern drafted from your measurements alone — and retired only for you." },
  { num: "02", title: "Made in Mumbai", text: "Cut, canvassed and finished by hand across our two ateliers on Swami Vivekanand Road — Santacruz and Bandra." },
  { num: "03", title: "Fitted Until Right", text: "A suit is finished when it disappears on you. We fit, refine and re-fit until the silhouette is unmistakably yours." },
];

export default function AboutPage() {
  return (
    <main data-testid="about-page">
      <Header />
      <PageHero overline="About Sven Suits" title="A suit made for" accent="one person." />

      <section className="bg-[#faf8f5] py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-6">
            <Reveal>
              {/* PLACEHOLDER COPY — client to replace */}
              <p className="text-base font-light leading-relaxed text-[#57534e]">
                Sven Suits is built on a simple idea: a suit should be made for one person,
                not everyone. Every piece is cut, fitted, and finished by hand in Mumbai —
                for men who don't compromise on how they show up.
              </p>
              <p className="mt-6 text-base font-light leading-relaxed text-[#57534e]">
                From black-tie tuxedos to ceremonial eveningwear and everyday tailoring,
                each commission moves through the same unhurried hands — measured in person,
                at your home, or over video, and fitted until the silhouette is unmistakably yours.
              </p>
            </Reveal>
            <div className="mt-14">
              {VALUES.map((v, i) => (
                <Reveal key={v.num} delay={0.08 * i}>
                  <div className="flex gap-6 py-7 border-t border-[#e7e2da] last:border-b">
                    <span className="font-accent italic text-2xl text-[#c5a059] leading-none pt-1">{v.num}</span>
                    <div>
                      <h3 className="font-display text-lg text-[#141414]">{v.title}</h3>
                      <p className="mt-2 text-sm font-light leading-relaxed text-[#57534e]">{v.text}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.2}>
              <div className="mt-12">
                <BookCta testId="about-book-cta" />
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-6">
            <Reveal delay={0.15} y={60}>
              <div className="grid grid-cols-2 gap-4">
                <img src="/images/products/sven-10985.jpg" alt="Midnight jacquard bespoke suit" className="w-full h-[340px] lg:h-[420px] object-cover object-top mt-10" />
                <img src="/images/products/sven-11849.jpg" alt="Navy shawl-lapel tuxedo" className="w-full h-[340px] lg:h-[420px] object-cover object-top" />
              </div>
              <p className="mt-4 font-mono-ov text-[10px] tracking-[0.22em] uppercase text-[#57534e]/70 text-right">From the atelier lookbook</p>
            </Reveal>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
